import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=5de7e6ec&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5de7e6ec')) {
      api.createRecord('5de7e6ec', component.options)
    } else {
      api.reload('5de7e6ec', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=5de7e6ec&", function () {
      api.rerender('5de7e6ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2y5ZoDM6J7kvH/JS/comp/IncreaseNumber.vue"
export default component.exports